import { NavLink, Logo, Nav, Header } from "./Header.styles";
import logo from "images/logo.png";
import { useLocation } from "react-router-dom";

export const HeaderComponent = () => {
  const location = useLocation();
  return (
    <Header>
      <Logo>
        <NavLink to="/" noAnimation={true}>
          <img src={logo} alt="logo" />
        </NavLink>
      </Logo>
      <Nav>
        {/* <NavLink className={location.pathname === "/" ? "active" : ""} to="/">
          HOME
        </NavLink> */}
        {/* <NavLink
          className={location.pathname === "/games" ? "active" : ""}
          to="/games"
        >
          GAMES
        </NavLink> */}
        <NavLink
          className={location.pathname === "/press" ? "active" : ""}
          to="https://press.telazer.com"
          target="_blank"
        >
          PRESS
        </NavLink>
        {/* <NavLink
          className={location.pathname === "/about" ? "active" : ""}
          to="/about"
        >
          ABOUT
        </NavLink> */}
      </Nav>
    </Header>
  );
};
